import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [

    {
        id: 1,
        label: 'Home',
        icon: 'bx-home',
        link: '/home',
    },
    {
        id: 2,
        label: 'Bateas',
        icon: 'bx-briefcase-alt',
        link: '/bateas',
        subItems: [
            {
                id: 21,
                label: 'Lista',
                icon: 'bx-file',
                link:'/bateas'
            },
            {
                id: 22,
                label: 'Mapa',
                icon: 'bx-file',
                link:'/bateas-position'
            }, 
           
        ]

    },
    {
        id: 3,
        label: 'Usuarios',
        icon: 'bx-user',
        link:'/usuarios'
    },
    {
        id: 4,
        label: 'Clientes',
        icon: 'bx-task',
        link:'/clientes'
    },
    {
        id: 5,
        label: 'Intrusiones',
        icon: 'bx-bell',
        link:'/intrusiones'
    },
    {
        id: 6,
        label: 'Informes',
        icon: 'bx-file-blank',
        link:'/configuracion',
        subItems: [
            {
                id: 61,
                label: 'Contratos',
                icon: 'bx-file',
                link:'/contratos'
            },
            {
                id: 62,
                label: 'Ficheros Técnicos',
                icon: 'bx-file',
                link:'/ficheros'
            },
            {
                id: 63,
                label: 'Ficheros Clientes',
                icon: 'bx-camera',
                link:'/ficheros-clientes'
            },
            {
                id: 64,
                label: 'Dispositivos',
                icon: 'bx-camera',
                link:'/dispositivos'
            }, 
           
        ]
    },
    {
        id: 7,
        label: 'Configuraciones',
        icon: 'bx-cog',
        link:'/configuracion',
        subItems: [
            {
                id: 71,
                label: 'General',
                icon: 'bx-cog',
                link:'/configuracion',
            },
            {
                id: 72,
                label: 'Roles',
                icon: 'bx-cog',
                link:'/configuracion_roles'
            },
        ]
    },
    {
        id: 8,
        label: 'Registros',
        icon: 'bx-file',
        link:'/Registros',
        subItems: [
            {
                id: 81,
                label: 'Email',
                icon: 'bx-cog',
                link:'/informesemail',
            },
            {
                id: 84,
                label: 'Notificaciones',
                icon: 'bx-cog',
                link:'/informesnotificaciones',
            },
            {
                id: 82,
                label: 'Acciones Web',
                icon: 'bx-cog',
                link:'/informes',
            },
            {
                id: 83,
                label: 'Alertas e intrusiones',
                icon: 'bx-bell',
                link: '/alertas',
            },
            {
                id: 84,
                label: 'Incidencias de servicios',
                icon: 'bx-bell',
                link: '/incidencias',
            }
        ]
    },
    {
        id: 9,
        label: 'Salir',
        icon: 'bx-exit',
        link:'/account/login'
    },
    ];

